export default "__VITE_ASSET__0d19dfd4__"